/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCodesandbox(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M10.627 1.579a2.75 2.75 0 012.746 0h.002l3.233 1.848a.75.75 0 01.477.272l3.29 1.88c.345.2.642.472.871.796a.75.75 0 01.207.342c.194.384.297.81.297 1.241V15.96a2.753 2.753 0 01-1.375 2.38l-.003.001-3.287 1.879a.75.75 0 01-.477.272l-3.233 1.848h-.002a2.75 2.75 0 01-.982.34.746.746 0 01-.782 0 2.75 2.75 0 01-.984-.34L7.392 20.49a.75.75 0 01-.477-.272L3.628 18.34l-.003-.002A2.75 2.75 0 012.25 15.96v-3.988-4.013c0-.432.103-.858.298-1.242a.751.751 0 01.206-.342 2.75 2.75 0 01.871-.796l.003-.001 3.287-1.879a.75.75 0 01.477-.272l3.235-1.848zM7.55 5.064L4.537 6.786 12 11.103l7.463-4.317-3.013-1.722-4.075 2.354a.75.75 0 01-.75 0L7.55 5.064zm7.392-.861l-2.317-1.324a1.25 1.25 0 00-1.25 0l-.003.001-2.314 1.323L12 5.903l2.942-1.7zm5.308 3.86l-7.5 4.339v8.566l3-1.714v-4.695a.75.75 0 01.375-.65l4.125-2.383V8.063zm0 5.195l-3 1.734v3.405l2.375-1.357.001-.001a1.248 1.248 0 00.624-1.08v-2.7zm-9 7.71v-8.566l-7.5-4.339v3.463l4.125 2.384a.75.75 0 01.375.649v4.695l3 1.714zm-4.5-2.571v-3.405l-3-1.734v2.7a1.25 1.25 0 00.624 1.08l.001.002 2.375 1.357z'
      />
    </svg>
  );
}

export default SvgCodesandbox;
